declare global {
  interface Window {
    dataLayer: any[];
  }
}

export const envType = {
  NUMBER: "number",
  BOOLEAN: "boolean",
  ARRAY: "array",
  STRING: "string",
};

export const envChangeType = (target: string, type = envType.STRING) => {
  switch (type) {
    case envType.NUMBER:
    case envType.BOOLEAN:
      return JSON.parse(process.env[target] || "");
    case envType.ARRAY:
      return process.env[target]?.split(",");
    default:
      return process.env[target];
  }
};
